/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-14 09:57:36
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-19 19:05:56
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../app/store";
import { recentTimelogoutlist, recentTimelogoutlistParams, recentTimepage, recentTimeParams } from "../../services/recentTime";

const initialState = {
    RecentTimeData: [],
    Total: 0,
    Current: 1,
    keyword: "",
    StorehouseId: 0,
    MaterialsCategory: 0,
    DeadlineEnd: "",
    DeadlineStart: "",
    Rejection: false,
}

export const recentTimeSlice = createSlice({
    name: "recentTime",
    initialState,
    reducers: {
        setData(state, action) {
            state.RecentTimeData = action.payload
        },
        setTotal(state, action) {
            state.Total = action.payload
        },
        setCurrent(state, action) {
            state.Current = action.payload
        },
        setRejection(state, action) {
            state.Rejection = action.payload
        }
    }
})

export function pageRecentTime(
    params: recentTimeParams
): RootThunk {
    return api(recentTimepage(params), (data: any, dispatch) => {
        console.log(data.total)
        dispatch(setData(data.records))
        dispatch(setTotal(data.total))
    })
}

export const logoutlistrecentTimeAsync = createAsyncThunk<
    void, recentTimelogoutlistParams, RootThunkApi<void>
>("Putstorage/savelist", async (params, api) => {
    return sendAsync(recentTimelogoutlist(params), api)
})

export const { setData, setTotal, setCurrent, setRejection } = recentTimeSlice.actions

export const selectRecentTimeData = (state: RootState) => state.recentTime.RecentTimeData

export const selectTotal = (state: RootState) => state.recentTime.Total

export const selectCurrent = (state: RootState) => state.recentTime.Current

export const selectRejection = (state: RootState) => state.recentTime.Rejection

export default recentTimeSlice.reducer